module.exports = __webpack_public_path__ + "res/0-img_guide.4065bcf750030ae39813b2fba5e04337.png";